import { render, staticRenderFns } from "./EdlordersWaitingPayment.vue?vue&type=template&id=40564ff4&"
import script from "./EdlordersWaitingPayment.vue?vue&type=script&lang=js&"
export * from "./EdlordersWaitingPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports